import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function emailTLDValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = /^.+\.[^\.\@]+$/;
    return (control !== null && control.value !== null && control.value !== undefined)
      && regex.test(control.value)
      ? null
      : { email: { value: control.value } };
  };
}
